import store from '@/store'
import { find } from 'lodash'
import { accessDeniedToaster } from "@/routes/guards/abilities/pop-denied-access";

let guard = () => new Promise( (resolve, reject) => {
    return (
        find(store.getters['auth/abilities'], ability =>
        ability.name === 'manage-dynamic-statuses' &&
        ability.entity_type === 'App\\Models\\DynamicStatus'
        )
    ) ? resolve()
        : accessDeniedToaster(reject, {
            name: 'dashboard'
        })
})

export default {
    name: 'manage-dynamic-statuses',
    run: guard
}